/**
 * Author：brand
 * Creation Time：2019-08-28 16:01
 * Email：brandhuang@qq.com
 */

/**
 * Author: brand
 * Creation Time: 2019-02-19 11:40
 * Description: 判断是否有className
 */
function hasClass (element, cls) {
  return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1
}
export { hasClass }

/**
 * Author: brand
 * Creation Time: 2019-02-19 11:40
 * Description: 移除className
 */
export function removeClass (el, className) {
  if (!hasClass(el, className)) {
    return
  }
  let newClass = el.className.split(' ')
  newClass.forEach(function (val, index, newClass) {
    if (val === className) {
      newClass.splice(index, 1)
    }
  })
  el.className = newClass.join(' ')
}
/**
 * Author: brand
 * Creation Time: 2019-02-19 11:40
 * Description: 添加className
 */
export function addClass (el, className) {
  if (hasClass(el, className)) {
    return
  }
  let newClass = el.className.split(' ')
  newClass.push(className)
  el.className = newClass.join(' ')
}

/**
 * 发送消息的格式化时间
 * @returns {string}
 */
export function getTimes () {
  let currentDate = new Date()
  let Year = currentDate.getFullYear()
  let Month = currentDate.getMonth() < 9 ? '0' + (currentDate.getMonth() + 1) : currentDate.getMonth() + 1
  let Dates = currentDate.getDate() < 10 ? '0' + currentDate.getDate() : currentDate.getDate()
  let Hour = currentDate.getHours() < 10 ? '0' + currentDate.getHours() : currentDate.getHours()
  let Minutes = currentDate.getMinutes() < 10 ? '0' + currentDate.getMinutes() : currentDate.getMinutes()
  let Seconds = currentDate.getSeconds() < 10 ? '0' + currentDate.getSeconds() : currentDate.getSeconds()

  return '' + Year + '-' + Month + '-' + Dates + ' ' + Hour + ':' + Minutes + ':' + Seconds
}

// 获取url后面的参数
export function GetQueryString (name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r != null){
    return unescape(r[2])
  }else{
    if(location.hash=='' || location.hash == '#428EFE'){ // 系统设置-接入设置-网站接入-移动端聊天按钮没设置的后台默认是#428EFE 临时加判断
      return null
    }
    // hash参数
    var arr = (location.hash || '').split('?')[1].split('&')
    var params = {}
    for (var i = 0; i < arr.length; i++) {
      var data = arr[i].split('=')
      if (data.length === 2) {
        params[data[0]] = data[1]
      }
    }
    if(params!=null){
      return params[name]
    }else{
      return null
    }
  }
}


export function renderUrl (str) {
  let reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g
  // return str.replace(reg, "<a href='$1$2' target='_blank'>$1$2</a>")
  let areg = /<a.*?>(.*?)<\/a>/ig
  let imgreg = /<img.*?>/ig
  let aArr = []
  let imgArr = []
  let phoneReg = /(1[3|4|5|7|8|9][\d]{9}|0[\d]{2,3}-[\d]{7,8}|400[-]?[\d]{3}[-]?[\d]{4})/g
  let s = str.replace(imgreg, function (word1, word2) {
    if (str.match(imgreg)) {
      // imgArr = str.match(imgreg)
      let isMobile = (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))
      if(isMobile){
        imgArr = str.match(imgreg)
      }else {
        var NewReg=new RegExp("http|https");
        NewReg.test(word1);
        if (NewReg.test(word1)) {
          word1.replace(reg, function (word11, word21) {
            let imgEL = `<a href="${word11}" target="_blank"><img src="${word11}" alt=""></a>`
            imgArr.push(imgEL)
          })
        } else {
          imgArr = str.match(imgreg)
        }
      }
      return '<IMGDONTCHANGE>'
    }
  }).replace(areg, function (word1, word2) {
    if (str.match(areg)) {
      let arr = []
      // arr.push('<a href=' + word2 + " target='_blank'>" + word2 + '</a>')
      aArr = str.match(areg)
      // aArr = arr
      return '<ADONTCHANGE>'
    }
  }).replace(reg, function (word1, word2) {
    if (word2) {
      return '<a href=' + word1 + " target='_blank'>" + word1 + '</a>'
    } else {
      return '<a href=http://' + word1 + " target='_blank'>" + word1 + '</a>'
    }
  }).replace(phoneReg, function (word1, word2) {     return `<a href="tel:${word1}">${word1}</a>`  })

  function set (str, ary, rule) {
    let tmp = str.split(rule)
    let s = ''
    if (tmp.length > 1) {
      for (let i = 0; i < tmp.length; i++) {
        s += tmp[i] + (typeof ary[i] === 'undefined' ? '' : ary[i])
      }
    }
    return s !== '' ? s : str
  }

  let s1 = set(s, aArr, /<ADONTCHANGE>/ig)
  let s2 = set(s1, imgArr, /<IMGDONTCHANGE>/ig)
  return s2
}
// 仿微信聊天时间展示
export const JUST_NOW = 1000 * 60 * 3 // 3分钟内
export const IN_SECOND = 1000 * 60 // 一分钟
export const IN_MINUTE = 1000 * 60 * 60 // 一小时
export const IN_HOUR = 1000 * 60 * 60 * 12 // 12小时
export const IN_DAY = 1000 * 60 * 60 * 24 * 1 // 1天
export const IN_MONTH = 1000 * 60 * 60 * 24 * 30 // 1个月
export function msgTimeRender (time1) {
  if (time1) {
    let time = time1.replace(/-/g, '/')
    let msgTimeTmp = new Date(time).getTime() // 每条消息的时间戳
    let msgTime = new Date(time) // 每条消息的时间
    let currentTimeTmp = new Date().getTime() // 当前 时间戳
    let currentTime = new Date() // 当前 时间
    let diff = currentTimeTmp - msgTimeTmp
    if (msgTime.getFullYear() === currentTime.getFullYear()) { // 今年
      if (msgTime.getMonth() === currentTime.getMonth() && msgTime.getDate() === currentTime.getDate()) { // 今天
        // if (diff < JUST_NOW) {
        //   return ''
        // } else {
        //   return '今天 ' + msgTime.getHours() + ':' + msgTime.getMinutes()
        // }
        return '今天 ' + (msgTime.getHours() < 10 ? '0' + msgTime.getHours() : msgTime.getHours()) + ':' + (msgTime.getMinutes() < 10 ? '0' + msgTime.getMinutes() : msgTime.getMinutes())
      } else {
        return (msgTime.getMonth() + 1) + '月' + msgTime.getDate() + '日 ' + (msgTime.getHours() < 10 ? '0' + msgTime.getHours() : msgTime.getHours()) + ':' + (msgTime.getMinutes() < 10 ? '0' + msgTime.getMinutes() : msgTime.getMinutes())
      }
    } else { // 今年以前
      return msgTime.getFullYear() + '年' + (msgTime.getMonth() + 1) + '月' + msgTime.getDate() + '日 ' + (msgTime.getHours() < 10 ? '0' + msgTime.getHours() : msgTime.getHours()) + ':' + (msgTime.getMinutes() < 10 ? '0' + msgTime.getMinutes() : msgTime.getMinutes())
    }
  }
}


/**
 * 压缩裁剪图片
 */
export function resizeImage(file,maxSize) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();

        reader.onload = function () {
            var img = new Image();

            img.onload = function () {
                var w = this.naturalWidth;
                var h = this.naturalHeight;
                // 如果图片尺寸大于所传最大尺寸则压缩
                if (file.size<maxSize) {
                    resolve(file);
                    return;
                }
                var level = 0.6;
                var multiple = file.size/maxSize
                var resizeW = w / multiple;
                var resizeH = h / multiple;

                var canvas = document.createElement("canvas");

                canvas.width = resizeW;
                canvas.height = resizeH;

                var ctx = canvas.getContext("2d");

                ctx.drawImage(img, 0, 0, resizeW, resizeH);

                var base64Img = canvas.toDataURL(file.type, level);
                var arr = base64Img.split(",");

                resolve(arr[1]);
            };

            img.src = this.result;
        };

        reader.readAsDataURL(file);
    });
}

/**
 * 将图片的base64字符串转换为Blob对象
 */
export function convertToBlob(base64Str, fileType) {
    var base64 = window.atob(base64Str);
    var len = base64.length;
    var buff = new ArrayBuffer(len);
    var uarr = new Uint8Array(buff);

    for (var i = 0; i < len; i++) {
        uarr[i] = base64.charCodeAt(i);
    }

    var blob = null;

    try {
        blob = new Blob([buff], { type: fileType });
    } catch (e) {
        var BlobBuilder = window.BlobBuilder = (
            window.BlobBuilder ||
            window.WebKitBlobBuilder ||
            window.MozBlobBuilder ||
            window.MSBlobBuilder
        );

        if (e.name === "TypeError" && BlobBuilder) {
            var builder = new BlobBuilder();
            builder.append(buff);
            blob = builder.getBlob(fileType);
        }
    }

    return blob;
}
